import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@mui/styles';
import { Box, Card, CardContent, Tooltip, Typography } from '@mui/material';

import { FiUploadCloud } from 'react-icons/fi';
import { FaTrash } from 'react-icons/fa';
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';

const img = {
  height: '100%',
};

const useStyles = makeStyles((theme) => ({
  dropzone: {
    width: '100%',
    height: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  iconPreview: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    height: '100%',
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  uploadIcon: {
    fontSize: '42px',
    color: theme.palette.primary.main,
  },
  deleteIcon: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    right: 0,
    position: 'absolute',
    cursor: 'pointer',
  },
}));

const Thumbs = ({ file: { preview = null } }) =>
  !!preview && <img src={preview} style={img} />;

const FileUploadPreview = ({
  accept,
  preview,
  graphicKey,
  onRemovedFile,
  onSelectedFile,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [file, setFile] = useState(preview);
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    onDrop: (acceptedFiles) => {
      onSelectedFile(graphicKey, acceptedFiles[0]);
      setFile(
        Object.assign(acceptedFiles[0], {
          preview: URL.createObjectURL(acceptedFiles[0]),
        }),
      );
    },
  });

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      URL.revokeObjectURL(file.preview);
    },
    [file],
  );

  return (
    <Card
      // elevation={3}
      style={{
        width: '100%',
        padding: '20px',
        height: '140px',
        textAlign: 'center',
        backgroundColor: '#FAFAFA',
      }}>
      {/* {!file.preview && <CardHeader style={{ textAlign: 'center' }} />} */}
      {!file.preview && (
        <CardContent className={classes.dropzone}>
          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} />
            <Box component={FiUploadCloud} className={classes.uploadIcon} />
            <Typography style={{ color: '#707070' }}>Upload from PC</Typography>
          </div>
        </CardContent>
      )}
      {file.preview && (
        <CardContent className={classes.iconPreview} style={{ padding: 0 }}>
          <ConfirmDialog
            icon
            divider
            confirmText={t('delete')}
            rejectText={t('cancel')}
            content={t('delete_file_message')}
            title={t('delete_file')}
            btnClassName={classes.deleteButton}
            confirmAction={() => {
              setFile({});
              onRemovedFile(file.id, file.name);
            }}>
            <Tooltip title={t('delete')} aria-label="delete" arrow>
              <Box component={FaTrash} className={classes.deleteIcon} />
            </Tooltip>
          </ConfirmDialog>

          <Thumbs file={file} />
        </CardContent>
      )}
    </Card>
  );
};

FileUploadPreview.defaultProps = {
  preview: {},
  accept: 'image/*',
};

FileUploadPreview.propTypes = {
  preview: PropTypes.object,
  graphicKey: PropTypes.string,
  onRemovedFile: PropTypes.func,
  onSelectedFile: PropTypes.func,
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default FileUploadPreview;
